import React, { useState, useEffect } from "react";
import StatusBadge from "./components/StatusBadge";
import { getChargeHistoryAPI } from "../../../../api/index";
import { useAuth } from "../../../../hooks/useAuth";
import "./ChargeHistory.css";

const ChargeHistory = () => {
  const { user } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const itemsPerPage = 50;

  useEffect(() => {
    const fetchChargeHistory = async () => {
      setLoading(true);
      setError(null);

      // ✅ 맨 처음에 로그인 상태 체크 (API 호출 전에)
      if (!user?.id) {
        const mockChargeHistory = [
          {
            id: 1,
            amount: 200000,
            status: "PENDING",
            created_at: "2025-08-24T10:30:00.000Z",
            updated_at: "2025-08-24T11:00:00.000Z",
          },
          {
            id: 2,
            amount: 100000,
            status: "APPROVED",
            created_at: "2025-08-20T14:20:00.000Z",
            updated_at: "2025-08-20T14:20:00.000Z",
          },
          {
            id: 3,
            amount: 100000,
            status: "APPROVED",
            created_at: "2025-08-18T09:15:00.000Z",
            updated_at: "2025-08-18T16:45:00.000Z",
          },
        ];

        setData(mockChargeHistory);
        setTotalPages(1);
        setLoading(false);
        return; // ✅ 여기서 완전 종료 (API 호출 안 함)
      }

      // ✅ 여기까지 오면 로그인 상태이므로 API 호출
      try {
        const response = await getChargeHistoryAPI({
          page: currentPage,
          pageSize: itemsPerPage,
          web_member_id: user.id,
        });

        setData(response.data.list || []);
        setTotalPages(Math.ceil((response.data.total || 0) / itemsPerPage));
      } catch (err) {
        console.error("충전내역 에러:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchChargeHistory();
  }, [currentPage, itemsPerPage, user?.id]);

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  if (loading) {
    return (
      <div className="charge-history-container">
        <div className="history-header">
          <h3 className="history-title">충전 내역</h3>
        </div>
        <div>로딩 중...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="charge-history-container">
        <div className="history-header">
          <h3 className="history-title">충전 내역</h3>
        </div>
        <div>에러가 발생했습니다: {error}</div>
      </div>
    );
  }

  return (
    <div className="charge-history-container">
      <div className="history-header">
        <h3 className="history-title">충전 내역</h3>
        <div className="pagination-controls">
          <button onClick={handlePrevPage} disabled={currentPage === 1}>
            &lt;
          </button>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
        </div>
      </div>
      <ul className="charge-history-list">
        {data.map((item, index) => (
          <li key={item.id || index} className="charge-history-item">
            <div className="item-details">
              <span className="item-date">
                {new Date(item.created_at).toLocaleDateString("ko-KR")}
              </span>
              <span className="item-amount">
                {item.tax_invoice
                  ? `${
                      Math.round(item.amount / 1.1)?.toLocaleString("ko-KR") ||
                      "0"
                    }원 (세금포함 ${
                      item.amount?.toLocaleString("ko-KR") || "0"
                    }원)`
                  : `${item.amount?.toLocaleString("ko-KR") || "0"}원`}
              </span>
            </div>
            <StatusBadge status={item.status} />
          </li>
        ))}
      </ul>
      {data.length === 0 && (
        <div className="no-data-message">충전내역이 없습니다.</div>
      )}
    </div>
  );
};

export default ChargeHistory;
